import { Collapsible_Button_default } from "./chunk-VX7XXR6L.js";
import { CollapsibleContext } from "./chunk-P4FH6SY6.js";
import { Heading_default } from "./chunk-K742HG2N.js";
import { Icon_default } from "./chunk-HALE5GZ6.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Collapsible/Collapsible.Header.tsx
import { useContext, useMemo, cloneElement } from "react";
import clsx from "clsx";
import { jsx, jsxs } from "react/jsx-runtime";
var CollapsibleHeader = _a => {
  var _b = _a,
    {
      title: titleProp,
      secondaryAction,
      children,
      button = /* @__PURE__ */jsx(Collapsible_Button_default, {}),
      className
    } = _b,
    rest = __objRest(_b, ["title", "secondaryAction", "children", "button", "className"]);
  const {
    id
  } = useContext(CollapsibleContext);
  const title = useMemo(() => cloneElement(button, {
    children: titleProp
  }), [button, titleProp]);
  return /* @__PURE__ */jsxs("header", __spreadProps(__spreadValues({}, rest), {
    className: clsx("pd:collapsible__header", className),
    children: [/* @__PURE__ */jsx(Heading_default, {
      as: "span",
      variant: "display",
      size: "3",
      className: "pd:text-dim-800",
      children: title
    }), /* @__PURE__ */jsx("div", {
      id: "".concat(id, "-subtitle"),
      className: "pd:grow",
      children
    }), /* @__PURE__ */jsx("div", {
      className: "pd:z-20 pd:flex pd:grow-0 pd:text-dim-800",
      children: secondaryAction
    }), /* @__PURE__ */jsx(Icon_default, {
      icon: "double-chevron-down",
      className: "pd:collapsible__chevron"
    })]
  }));
};
var Collapsible_Header_default = CollapsibleHeader;
export { Collapsible_Header_default };